import { render, staticRenderFns } from "./productosCambios.vue?vue&type=template&id=da5c3ee8&scoped=true&"
import script from "./productosCambios.vue?vue&type=script&lang=js&"
export * from "./productosCambios.vue?vue&type=script&lang=js&"
import style0 from "./productosCambios.vue?vue&type=style&index=0&id=da5c3ee8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5c3ee8",
  null
  
)

export default component.exports